import { TokenHistoryLabel } from "kadow-jetpack-model";
import { tt } from "../../../../utils/i18n/i18n";

export const getPlaceholder = (cta_id: TokenHistoryLabel) => {
  switch (cta_id) {
    case TokenHistoryLabel.Google:
      return "";

    case TokenHistoryLabel.Facebook:
      return tt("jp_onboarding_socials_placeholder_facebook");

    case TokenHistoryLabel.SnapChat:
      return tt("jp_onboarding_socials_placeholder_snapchat");

    case TokenHistoryLabel.Instagram:
    case TokenHistoryLabel.IGStory:
      return tt("jp_onboarding_socials_placeholder_instagram");

    case TokenHistoryLabel.TikTok:
      return tt("jp_onboarding_socials_placeholder_tiktok");

    case TokenHistoryLabel.Deliveroo:
    case TokenHistoryLabel.UberEats:
    default:
      return "";
  }
};
